import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { doFetch } from '../redux/api/actions';
import { GET_LOCATIONS } from '../redux/api/constants';
import Layout from './layout';
import Search from './search';
import { useTranslation } from 'react-i18next';

const Categories = () => {
    return (
        <div className="categories-section">
            <div className="container">
                <div className="categories-grid">
                    <div className="category-card">
                        <div className="category-icon">
                            <i className="bi bi-compass"></i>
                        </div>
                        <h4>City Tours</h4>
                        <p>Explore hidden gems and local favorites</p>
                    </div>
                    <div className="category-card">
                        <div className="category-icon">
                            <i className="bi bi-cup-hot"></i>
                        </div>
                        <h4>Food & Drink</h4>
                        <p>Taste authentic local cuisine</p>
                    </div>
                    <div className="category-card">
                        <div className="category-icon">
                            <i className="bi bi-tree"></i>
                        </div>
                        <h4>Nature & Outdoors</h4>
                        <p>Discover natural wonders</p>
                    </div>
                    <div className="category-card">
                        <div className="category-icon">
                            <i className="bi bi-building"></i>
                        </div>
                        <h4>Art & Culture</h4>
                        <p>Experience local arts and history</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const HowItWorks = () => {
    return (
        <div className="how-it-works-section">
            <div className="container">
                <h2 className="section-title">How It Works</h2>
                <div className="steps-grid">
                    <div className="step-card">
                        <div className="step-number">1</div>
                        <h4>Find Your Experience</h4>
                        <p>Search by destination, dates, and group size to find the perfect local tour.</p>
                    </div>
                    <div className="step-card">
                        <div className="step-number">2</div>
                        <h4>Book with Confidence</h4>
                        <p>Choose an available date and book directly with your local guide.</p>
                    </div>
                    <div className="step-card">
                        <div className="step-number">3</div>
                        <h4>Enjoy the Adventure</h4>
                        <p>Meet your guide and experience the destination like a local.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const BecomeGuide = () => {
    const me = useSelector(state => state.API.me);
    const { t } = useTranslation();
    
    return (
        <div className="become-guide-section">
            <div className="container">
                <div className="become-guide-content">
                    <div className="become-guide-text">
                        <h2>Share your world with travelers</h2>
                        <p>{t('home-signup-ad')}</p>
                        {me ? (
                            <Link to="/tourguide" className="btn-primary">
                                Go to Dashboard
                            </Link>
                        ) : (
                            <Link to="/tourguide/about" className="btn-primary">
                                {t('become-tourguide')}
                                <i className="bi bi-arrow-right ms-2"></i>
                            </Link>
                        )}
                    </div>
                    <div className="become-guide-image">
                        <img 
                            src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=600&h=400&fit=crop" 
                            alt="Become a guide"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

function Home() {
    const dispatch = useDispatch();
    
    useEffect(() => {
        dispatch(doFetch(GET_LOCATIONS, "locations"));
    }, [dispatch]);

    const allDestinations = useSelector(state => state.API.locations);
    
    return (
        <Layout selected="home" nocontainer="true">
            <Search destinations={allDestinations} jumbo={true} />
            <Categories />
            <HowItWorks />
            <BecomeGuide />
        </Layout>
    );
}

export default Home;
